export const JOB_PREFERENCES = [
  { key: "cariste", label: "Cariste" },
  { key: "chef_equipe", label: "Chef d'équipe" },
  { key: "preparation_commandes", label: "Préparation de commandes" },
  { key: "manutentionnaire", label: "Manutentionnaire" },
  { key: "administratif", label: "Administratif" },
  { key: "encadrement", label: "Encadrement" },
];

export const CACES_CATEGORIES = [
  { key: "1A", label: "1A - Transpalettes à conducteur porté" },
  { key: "1B", label: "1B - Gerbeurs à conducteur porté" },
  { key: "2", label: "2 - Chariots tracteur (< 6000 kg)" },
  { key: "3", label: "3 - Chariots élévateurs (≤ 6000 kg)" },
  { key: "4", label: "4 - Chariots élévateurs (> 6000 kg)" },
  { key: "5", label: "5 - Chariots à mât rétractable" },
  { key: "6", label: "6 - Chariots hors production" },
];
